/* Knoxlabs Hardware PDP configurator — runs only on product.hardware template */
(function () {
  'use strict';

  var root = document.querySelector('[data-hw-main]');
  if (!root) return;

  var dataEl = document.getElementById('hw-data');
  if (!dataEl) return;
  var DATA = JSON.parse(dataEl.textContent);

  var fmt = new Intl.NumberFormat('en-US', { style: 'currency', currency: DATA.currency || 'USD' });
  function money(cents) { return fmt.format(cents / 100); }
  function updateSale(id, price) {
    var compare = Number((DATA.compareAtPrices || {})[String(id)]) || 0;
    var visible = DATA.showPrices && compare > price;
    root.querySelectorAll('[data-hw-compare-wrap],[data-hw-saving]').forEach(function(el) { el.hidden = !visible; });
    var original = root.querySelector('[data-hw-compare]');
    var savings = root.querySelector('[data-hw-saving]');
    if (visible && original && savings) {
      original.textContent = money(compare);
      savings.textContent = (DATA.savingsLabel || '__amount__').replace('__amount__', money(compare - price));
    }
  }
  updateSale(DATA.main.variantId, DATA.main.priceCents);
  function rate(value) {
    var parsed = parseFloat(value);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : 0;
  }

  /* ---------- State ---------- */
  var state = {
    qty: 1,
    compat: {},
    addons: {},
    plan: null
  };

  /* ---------- Gallery ---------- */
  var mainImg = root.querySelector('[data-hw-main-image]');
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-hw-thumb]'));
  var galleryIndex = thumbs.findIndex(function (thumb) { return thumb.classList.contains('is-active'); });
  if (galleryIndex < 0) galleryIndex = 0;
  function showGalleryImage(index) {
    if (!thumbs.length) return;
    galleryIndex = (index + thumbs.length) % thumbs.length;
    thumbs.forEach(function (thumb, i) {
      thumb.classList.toggle('is-active', i === galleryIndex);
      thumb.setAttribute('aria-current', i === galleryIndex ? 'true' : 'false');
    });
    if (mainImg) {
      mainImg.src = thumbs[galleryIndex].dataset.full;
      mainImg.srcset = '';
      var thumbImg = thumbs[galleryIndex].querySelector('img');
      if (thumbImg) mainImg.alt = thumbImg.alt;
    }
    var count = root.querySelector('[data-hw-gallery-count]');
    if (count) count.textContent = (galleryIndex + 1) + ' / ' + thumbs.length;
  }
  thumbs.forEach(function (t, i) {
    t.addEventListener('click', function () {
      showGalleryImage(i);
    });
  });
  var previousImage = root.querySelector('[data-hw-gallery-prev]');
  var nextImage = root.querySelector('[data-hw-gallery-next]');
  if (previousImage) previousImage.addEventListener('click', function () { showGalleryImage(galleryIndex - 1); });
  if (nextImage) nextImage.addEventListener('click', function () { showGalleryImage(galleryIndex + 1); });
  var lightbox = root.querySelector('[data-hw-lightbox]');
  var expandBtn = root.querySelector('[data-hw-expand]');
  if (expandBtn && lightbox) {
    expandBtn.addEventListener('click', function () {
      lightbox.querySelector('img').src = mainImg ? mainImg.src : '';
      lightbox.showModal();
    });
    lightbox.addEventListener('click', function () { lightbox.close(); });
  }

  /* ---------- Option matrix pills (split SKUs) ---------- */
  var matrix = DATA.matrix;
  if (matrix && matrix.members && matrix.members.length) {
    root.querySelectorAll('[data-hw-axis]').forEach(function (pill) {
      var axis = parseInt(pill.dataset.hwAxis, 10);
      var value = pill.dataset.hwValue;
      var desired = matrix.current.slice();
      desired[axis] = value;
      var exists = matrix.members.some(function (m) {
        return desired.every(function (v, i) { return !v || !m.values[i] || m.values[i] === v; });
      });
      if (!exists) pill.classList.add('is-unavailable');
      pill.addEventListener('click', function () {
        if (pill.classList.contains('is-active')) return;
        var want = matrix.current.slice();
        want[axis] = value;
        var exact = matrix.members.find(function (m) {
          return want.every(function (v, i) { return !v || m.values[i] === v; });
        });
        var target = exact || matrix.members.find(function (m) { return m.values[axis] === value; });
        if (target && target.url) window.location.href = target.url;
      });
    });
  }

  /* ---------- Native variant option pills ---------- */
  if (DATA.variants && DATA.variants.length) {
    var sel = (DATA.currentOptions || []).slice();
    var priceEl = root.querySelector('[data-hw-price]');
    root.querySelectorAll('[data-hw-opt]').forEach(function (pill) {
      pill.addEventListener('click', function () {
        var idx = parseInt(pill.dataset.hwOpt, 10);
        sel[idx] = pill.dataset.hwOptvalue;
        var match = DATA.variants.find(function (v) {
          return v.options.every(function (o, i) { return o === null || sel[i] === undefined || sel[i] === null || o === sel[i]; });
        });
        if (!match) {
          match = DATA.variants.find(function (v) { return v.options[idx] === sel[idx]; });
          if (match) sel = match.options.slice();
        }
        if (!match) return;
        DATA.main.variantId = match.id;
        DATA.main.priceCents = match.priceCents;
        updateSale(match.id, match.priceCents);
        DATA.main.tariffRate = rate(match.tariffRate);
        DATA.main.creditCardFee = rate(match.creditCardFee);
        if (priceEl && DATA.showPrices) priceEl.textContent = money(match.priceCents);
        root.querySelectorAll('[data-hw-opt]').forEach(function (p) {
          var i = parseInt(p.dataset.hwOpt, 10);
          p.classList.toggle('is-active', p.dataset.hwOptvalue === sel[i]);
        });
        root.querySelectorAll('[data-hw-optlabel]').forEach(function (l) {
          var i = parseInt(l.dataset.hwOptlabel, 10);
          if (sel[i]) l.textContent = sel[i];
        });
        render();
      });
    });
  }

  /* ---------- Compatible hardware picker (toggle) ---------- */
  root.querySelectorAll('[data-hw-compat]').forEach(function (card) {
    card.addEventListener('click', function () {
      var id = card.dataset.hwCompat;
      if (state.compat[id]) {
        delete state.compat[id];
        card.classList.remove('is-active');
      } else {
        state.compat[id] = {
          variantId: card.dataset.variantId,
          title: card.dataset.title,
          priceCents: parseInt(card.dataset.price, 10),
          tariffRate: rate(card.dataset.tariffRate),
          creditCardFee: rate(card.dataset.creditCardFee)
        };
        card.classList.add('is-active');
      }
      render();
    });
  });

  /* ---------- Add-on steppers ---------- */
  root.querySelectorAll('[data-hw-addon]').forEach(function (card) {
    var id = card.dataset.hwAddon;
    var input = card.querySelector('input');
    var addButton = card.querySelector('[data-hw-add]');
    var stepper = card.querySelector('.hw-qty');
    function setQty(q) {
      if (!Number.isFinite(q)) q = 0;
      q = Math.max(0, Math.min(99, q));
      input.value = q;
      if (addButton) addButton.hidden = q > 0;
      if (stepper) stepper.hidden = q === 0;
      if (q > 0) {
        state.addons[id] = {
          variantId: card.dataset.variantId,
          title: card.dataset.title,
          priceCents: parseInt(card.dataset.price, 10),
          tariffRate: rate(card.dataset.tariffRate),
          creditCardFee: rate(card.dataset.creditCardFee),
          qty: q
        };
        card.classList.add('is-selected');
      } else {
        delete state.addons[id];
        card.classList.remove('is-selected');
      }
      render();
    }
    if (addButton) addButton.addEventListener('click', function () { setQty(1); });
    card.querySelector('[data-hw-minus]').addEventListener('click', function () { setQty(parseInt(input.value, 10) - 1); });
    card.querySelector('[data-hw-plus]').addEventListener('click', function () { setQty(parseInt(input.value, 10) + 1); });
    input.addEventListener('change', function () { setQty(parseInt(input.value, 10) || 0); });
  });

  root.querySelectorAll('[data-hw-reveal-group]').forEach(function (group) {
    var toggle = group.querySelector('[data-hw-reveal]');
    if (!toggle) return;
    var hiddenCards = Array.prototype.slice.call(group.querySelectorAll('.hw-addon.is-collapsed'));
    toggle.addEventListener('click', function () {
      var expanded = toggle.getAttribute('aria-expanded') !== 'true';
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      hiddenCards.forEach(function (card) { card.classList.toggle('is-collapsed', !expanded); });
      toggle.textContent = expanded ? toggle.dataset.lessLabel : toggle.dataset.moreLabel + ' ' + hiddenCards.length + ' more';
    });
  });

  /* ---------- Protection plans (radio behaviour) ---------- */
  root.querySelectorAll('[data-hw-plan]').forEach(function (card) {
    function selectPlan() {
      root.querySelectorAll('[data-hw-plan]').forEach(function (x) {
        x.classList.remove('is-active');
        x.setAttribute('aria-checked', 'false');
      });
      card.classList.add('is-active');
      card.setAttribute('aria-checked', 'true');
      var vid = card.dataset.variantId;
      state.plan = vid ? {
        variantId: vid,
        title: card.dataset.title,
        priceCents: parseInt(card.dataset.price || '0', 10),
        tariffRate: rate(card.dataset.tariffRate),
        creditCardFee: rate(card.dataset.creditCardFee)
      } : null;
      render();
    }
    card.addEventListener('click', selectPlan);
    card.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        selectPlan();
      }
    });
  });

  /* ---------- Main quantity ---------- */
  var qtyInput = root.querySelector('[data-hw-qty] input');
  if (qtyInput) {
    root.querySelector('[data-hw-qty] [data-hw-minus]').addEventListener('click', function () { setMainQty(state.qty - 1); });
    root.querySelector('[data-hw-qty] [data-hw-plus]').addEventListener('click', function () { setMainQty(state.qty + 1); });
    qtyInput.addEventListener('change', function () { setMainQty(parseInt(qtyInput.value, 10) || 1); });
  }
  function setMainQty(q) {
    state.qty = Math.max(1, Math.min(999, q));
    if (qtyInput) qtyInput.value = state.qty;
    render();
  }

  /* ---------- Summary render (base + tariff + card fee = Shopify price) ---------- */
  var summaryList = root.querySelector('[data-hw-summary]');
  var totalEl = root.querySelector('[data-hw-total]');
  function lines() {
    var out = [];
    if (DATA.main && DATA.main.variantId) {
      out.push({ title: DATA.main.title, qty: state.qty, cents: DATA.main.priceCents * state.qty, tariffRate: rate(DATA.main.tariffRate), creditCardFee: rate(DATA.main.creditCardFee) });
    }
    Object.keys(state.compat).forEach(function (k) {
      var it = state.compat[k];
      out.push({ title: it.title, qty: 1, cents: it.priceCents, tariffRate: it.tariffRate, creditCardFee: it.creditCardFee });
    });
    Object.keys(state.addons).forEach(function (k) {
      var it = state.addons[k];
      out.push({ title: it.title, qty: it.qty, cents: it.priceCents * it.qty, tariffRate: it.tariffRate, creditCardFee: it.creditCardFee });
    });
    if (state.plan) out.push({ title: state.plan.title, qty: 1, cents: state.plan.priceCents, tariffRate: state.plan.tariffRate, creditCardFee: state.plan.creditCardFee });
    return out;
  }
  function render() {
    if (!summaryList) return;
    var ls = lines();
    var total = ls.reduce(function (s, l) { return s + l.cents; }, 0); // final = Shopify price(s)
    var itemRows = [];
    var parts = ls.reduce(function (totals, line) {
      var feeRate = rate(line.creditCardFee);
      var tariffRate = rate(line.tariffRate);
      var beforeFee = feeRate > 0 ? Math.round(line.cents / (1 + feeRate)) : line.cents;
      var base = tariffRate > 0 ? Math.round(beforeFee / (1 + tariffRate)) : beforeFee;
      itemRows.push({ title: line.title, qty: line.qty, cents: base });
      totals.base += base;
      totals.tariff += beforeFee - base;
      totals.cardFee += line.cents - beforeFee;
      return totals;
    }, { base: 0, tariff: 0, cardFee: 0 });
    var rows = '';
    if (DATA.showPrices) {
      itemRows.forEach(function (item) {
        rows += '<div class="hw-summary__row"><span>' + escapeHtml(item.title) + ' × ' + item.qty + '</span><strong>' + money(item.cents) + '</strong></div>';
      });
      if (parts.tariff > 0) {
        rows += '<div class="hw-summary__row"><span>U.S. import tariff (where applicable)</span><strong>' + money(parts.tariff) + '</strong></div>';
      }
      if (parts.cardFee > 0) {
        rows += '<div class="hw-summary__row"><span>Credit-card processing (4%)</span><strong>' + money(parts.cardFee) + '</strong></div>';
      }
    }
    summaryList.innerHTML = rows;
    if (totalEl && DATA.showPrices) {
      totalEl.textContent = money(total);
      var totLabel = root.querySelector('.hw-summary__total span');
      if (totLabel) totLabel.textContent = 'Total';
    }
    var card = summaryList.closest('.hw-card');
    if (card) {
      var noteEl = card.querySelector('[data-hw-tariff-note]');
      var noteText = DATA.main && DATA.main.pricingNote ? DATA.main.pricingNote : '';
      if (noteText) {
        if (!noteEl) {
          noteEl = document.createElement('p');
          noteEl.setAttribute('data-hw-tariff-note', '');
          noteEl.style.cssText = 'margin:.6rem 0 0;font-size:13px;line-height:1.45;color:var(--knox-slate);';
          card.appendChild(noteEl);
        }
        noteEl.textContent = noteText;
      } else if (noteEl) { noteEl.textContent = ''; }
    }
  }
  function escapeHtml(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  /* ---------- Add to cart ---------- */
  var atc = root.querySelector('[data-hw-atc]');
  if (atc) {
    atc.addEventListener('click', function () {
      atc.disabled = true;
      atc.textContent = 'Adding…';
      var group = DATA.main.handle + '-' + Date.now().toString(36);
      var items = [];
      items.push({ id: parseInt(DATA.main.variantId, 10), quantity: state.qty, properties: { _configuration: group } });
      Object.keys(state.compat).forEach(function (k) {
        items.push({ id: parseInt(state.compat[k].variantId, 10), quantity: 1, properties: { _configuration: group } });
      });
      Object.keys(state.addons).forEach(function (k) {
        items.push({ id: parseInt(state.addons[k].variantId, 10), quantity: state.addons[k].qty, properties: { _configuration: group } });
      });
      if (state.plan) items.push({ id: parseInt(state.plan.variantId, 10), quantity: 1, properties: { _configuration: group } });

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        if (!r.ok) throw new Error('cart');
        window.location.href = '/cart';
      }).catch(function () {
        atc.disabled = false;
        atc.textContent = atc.dataset.label || 'Add To Cart';
        alert('Could not add to cart. Please try again.');
      });
    });
  }

  /* ---------- Jump chips: smooth scroll ---------- */
  root.querySelectorAll('[data-hw-jump]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var t = document.querySelector(a.getAttribute('href'));
      if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    });
  });

  /* ---------- Quote modal ---------- */
  var quote = root.querySelector('[data-hw-quote]');
  if (quote) {
    function variantTitle() {
      if (DATA.variants) {
        var v = DATA.variants.find(function (x) { return String(x.id) === String(DATA.main.variantId); });
        if (v) return v.title;
      }
      return '';
    }
    root.querySelectorAll('[data-hw-quote-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var set = function (sel, val) { var el = quote.querySelector(sel); if (el) el.value = val; };
        set('[data-hw-quote-vid]', DATA.main.variantId);
        var vt = variantTitle(); if (vt) set('[data-hw-quote-variant]', vt);
        var extras = [];
        Object.keys(state.compat).forEach(function (k) { extras.push(state.compat[k].title); });
        Object.keys(state.addons).forEach(function (k) { extras.push(state.addons[k].title + ' x' + state.addons[k].qty); });
        if (state.plan) extras.push(state.plan.title);
        set('[data-hw-quote-addons]', extras.join('; '));
        var q = quote.querySelector('[data-hw-quote-qty]'); if (q) q.value = state.qty;
        quote.showModal();
      });
    });
    quote.querySelectorAll('[data-hw-quote-close]').forEach(function (b) {
      b.addEventListener('click', function () { quote.close(); });
    });
    quote.addEventListener('click', function (e) { if (e.target === quote) quote.close(); });
  }

  /* ---------- Clamp overflow detection + drawer ---------- */
  document.querySelectorAll('[data-hw-clamp]').forEach(function (c) {
    if (c.scrollHeight <= c.clientHeight + 12) {
      c.classList.add('no-overflow');
      var btn = c.parentElement.querySelector('[data-hw-drawer-open]');
      if (btn) btn.hidden = true;
    }
  });
  var drawer = document.querySelector('[data-hw-drawer]');
  if (drawer) {
    if (!drawer.parentElement.hasAttribute('data-hw-drawer-host')) {
      var host = document.createElement('div');
      host.className = 'hw-pdp';
      host.setAttribute('data-hw-drawer-host', '');
      host.style.cssText = 'max-width:none;padding:0;margin:0;';
      document.body.appendChild(host);
      host.appendChild(drawer);
    }
    document.querySelectorAll('[data-hw-drawer-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var src = document.querySelector('[data-hw-drawer-src="' + btn.dataset.hwDrawerOpen + '"]');
        if (!src) return;
        drawer.querySelector('[data-hw-drawer-body]').innerHTML = src.innerHTML;
        drawer.querySelector('[data-hw-drawer-title]').textContent = btn.dataset.drawerTitle || '';
        drawer.hidden = false;
        document.documentElement.style.overflow = 'hidden';
      });
    });
    drawer.querySelectorAll('[data-hw-drawer-close]').forEach(function (b) {
      b.addEventListener('click', function () {
        drawer.hidden = true;
        document.documentElement.style.overflow = '';
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !drawer.hidden) {
        drawer.hidden = true;
        document.documentElement.style.overflow = '';
      }
    });
  }

  render();
})();



